import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import IMG_6 from 'assets/images/prev_arrow.svg'
import IMG_7 from 'assets/images/next_arrow.svg'
// Import Swiper styles start
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
// Import Swiper styles end

/**
 * @file 스마트 스쿠터 화면에서 이미지 관련 desc 영역의 swiper
 * @param {Array} data SCOOTER_MAIN_DESC_INFO.img_desc 값 / 스마트 스쿠터 메인 화면에서 desc 값
 */
function ScooterImgDescSwiper({ data }) {
    const settings = {
        className: 'swiper-describe-one swiper-box',
        direction: 'horizontal',
        modules: [Navigation],
        navigation: {
            // 네비게이션 적용, < >
            nextEl: '.swiper-describe-one>.slide-control-btn.next', // 다음 버튼 클래스명
            prevEl: '.swiper-describe-one>.slide-control-btn.prev', // 이전 버튼 클래스명
        },
        slidesPerView: 'auto', // 한 화면에 보이는 슬라이드 수
        //spaceBetween: 50, // px 단위 간격
        spaceBetween: 30,
        loop: false,
        centeredSlides: false,
        breakpoints: {
            100: {
                centeredSlides: false,
                spaceBetween: 24,
            },
            768: {
                centeredSlides: false,
                spaceBetween: 50,
                //spaceBetween: 48,
            },
            1180: {
                centeredSlides: false,
                spaceBetween: 50,
                //spaceBetween: 56,
            },
        },
    }

    return (
        <Swiper {...settings}>
            <button className="slide-control-btn prev">
                <img src={IMG_6} alt="prev arrow"></img>
            </button>

            <button className="slide-control-btn next">
                <img src={IMG_7} alt="next arrow"></img>
            </button>
            <div className="swiper-wrapper">
                {data.map((val2, i) => (
                    <SwiperSlide className="swiper-slide" key={'scooter-main-desc-swiper-slide-' + i}>
                        <div
                            className="img-box"
                            style={{
                                backgroundImage: `url(${val2.imgUrl})`,
                            }}></div>
                        <div className="text-box">
                            <div className="t1">{val2.title}</div>
                            <div className="sub">{val2.sub}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </div>
        </Swiper>
    )
}

export default ScooterImgDescSwiper
